import React, { useState, useEffect, Suspense } from 'react'
import { useParams } from 'react-router-dom'
import axios from 'axios'
import LoadingBar from 'react-top-loading-bar'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Header from '../Header/Header'
import Sidebar from '../Sidebar/Sidebar'
import Footer from '../Footer/Footer'
import styles from '../../App.module.css'
import classes from './WebLink.module.css'
// import SingleGroup from '../Global/SingleGroup'
import SingleWeblink from '../Global/Weblink'

function Weblink() {
  const { wid } = useParams();
  const [weblink, setWeblink] = useState([]);
  const [progress, setProgress] = useState(10);

  useEffect(() => {
    try{
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }catch(ex){}
  }, []);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/weblink.php?limit=12&wid=${wid}`)
        .then(response => {
            setWeblink(response.data);
            setProgress(100);
        })
    }, [wid]);

  return (
    <>
      <LoadingBar
        color='#f11946'
        progress={progress}
        onLoaderFinished={() => setProgress(0)}
      />
      <Header />
      <ToastContainer />
      <div className={styles.main_body}>
        <Suspense fallback="<div>Please wait...</div>">
          <Sidebar />
        </Suspense>
        <Suspense fallback="<div>Please wait...</div>">
          <div className={styles.main_content + ` main-content`}>
            <ins className='adsbygoogle p-4 pb-0'
                style={{ display: 'block' }}
                data-ad-client='ca-pub-8126596259429304'
                data-ad-slot='5153011292'
                data-ad-format='auto'
            />
            <div className="groups-component p-4 mb-5">
              <div className={classes.sec_heading}>
                <h2 className='m-0'>Web Page</h2>
              </div>
              <div className={classes.weblink}>
                {
                  SingleWeblink(weblink)
                }
              </div>
            </div>
            <Footer />
          </div>
        </Suspense>
      </div>
      </>
  )
}

export default Weblink